import { Form } from 'antd';
import { MasterUseCaseInterface } from 'application/usecases/MasterUseCase';
import { PropertyUseCaseInterface } from 'application/usecases/PropertyUseCase';
import { DetailPropertyComponent } from 'presentation/components/DetailProperty';
import { openErrorNoti, openSuccessNoti } from 'presentation/components/Notification';
import { PageTitle } from 'presentation/components/PageTitle';
import { completeFetching, startFetching } from 'presentation/redux/features/app/appSlice';
import { useAppDispatch, useAppSelector } from 'presentation/redux/hooks';
import { PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { commonHelpers } from 'utilities/helpers';
import { Detail } from '../CU-031-01/components/Detail';
import { DetailProperty } from '../CU-031-01/models/DetailProperty';
import { DesiredSellingPrice } from './components/DesiredSellingPrice';
import { NumberAndTitle } from './components/NumberAndTItle';
import { ListedPropertyRoomGetAssessmentDetail } from './models/Property';

const DEMO_DESCRIPTION =
    '説明が入ります説明が入ります説明が入ります説明が入ります説明が入ります説明が入ります説明が入ります説明が入ります説明が入ります説明が入ります説明が入ります説明が入ります説明が入ります説明が入ります説明が入ります説明が入ります説明が入ります説明が入ります説明が入ります説明が入ります説明が入ります説明が入ります説明が入ります説明が入ります';
interface props {
    propertyUseCase: PropertyUseCaseInterface;
    masterUseCase: MasterUseCaseInterface;
}
const CU03301Page = ({ propertyUseCase, masterUseCase }: props) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const { propertyId, registeredId } = useParams();

    const [detailProperty, setDetailProperty] = useState<DetailProperty>();
    const [detailAssessment, setDetailAssessment] =
        useState<ListedPropertyRoomGetAssessmentDetail>();
    const [isDisabled, setIsDisabled] = useState<boolean>(true);
    const [marketPriceResult, setMarketPriceResult] = useState<number | undefined>(0);
    const [askingSalePrice, setAskingSalePrice] = useState<number | undefined>(0);

    const storedInput = useAppSelector((state) => state.CU03101Slice.storedInput);

    useEffect(() => {
        (async () => {
            if (storedInput) form.setFieldsValue(storedInput);
            await Promise.all([
                getDetailProperty({ propertyId: Number(propertyId) }),
                getListedPropertyRoomGetAssessmentDetail({
                    listedPropertyId: Number(registeredId),
                }),
            ]);
        })();
    }, []);

    const getListedPropertyRoomGetAssessmentDetail = async (params: {
        listedPropertyId: number;
    }) => {
        try {
            dispatch(startFetching());
            const response = await propertyUseCase.getListedPropertyRoomGetAssessmentDetail(params);
            if (response.result) {
                const marketPriceResult = response.result?.marketPrice
                    ? commonHelpers.roundTenThousandYen(response.result?.marketPrice)
                    : undefined;
                const askingSalePrice = marketPriceResult;
                setIsDisabled(!marketPriceResult ? true : false);
                setMarketPriceResult(marketPriceResult);
                setAskingSalePrice(askingSalePrice);
                setDetailAssessment(response.result);
            }
        } catch (error: any) {
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };

    const getDetailProperty = async (params: { propertyId: number }) => {
        try {
            dispatch(startFetching());
            const response = await propertyUseCase.getDetailProperty(params);
            if (response.result) {
                setDetailProperty(response.result);
            }
        } catch (error: any) {
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };

    const submit = async (value: any) => {
        try {
            dispatch(startFetching());
            if (!registeredId) return;

            const response = await propertyUseCase.putListedPropertyAssessmentDetail({
                id: registeredId,
                askingSalePrice: value.price,
            });
            if (response.status === '200') {
                openSuccessNoti();
                navigate(
                    `${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_035_01}/${propertyId}/${registeredId}`,
                );
            }
        } catch (error: any) {
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };

    return (
        <>
            <div
                style={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    flexFlow: 'column',
                    paddingLeft: 20,
                }}
                className="CU-033-01-container  CU-031-01-container"
            >
                <PageTitle title="くわしく査定の結果" />
                <section
                    style={{
                        padding: '60px 0px 0px 0px',
                        height: '100%',
                        overflow: 'auto',
                        flexGrow: 1,
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                >
                    {detailProperty ? (
                        <section style={{ display: 'inline-block' }}>
                            <Detail data={detailProperty} />
                            <div style={{ height: 12 }}></div>
                            <DetailPropertyComponent
                                link={`${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_036_02}/${propertyId}/${registeredId}`}
                            />
                        </section>
                    ) : null}

                    <section
                        style={{
                            width: 351,
                            height: 'fit-content',
                            margin: '0px 0px 0px 69px',
                            padding: 0,
                        }}
                    >
                        <div className="title-badge badge-1 center-inside">想定売却価格</div>
                        <div
                            style={{ marginTop: 40, marginBottom: 40, width: '100%' }}
                            className="center-inside"
                        >
                            <div>
                                <span className="title-1 mr-[8px]">
                                    {marketPriceResult
                                        ? marketPriceResult.toLocaleString('en-US', {
                                              maximumFractionDigits: 2,
                                          })
                                        : 0}
                                </span>
                                <span className="title-1-unit">万円</span>
                            </div>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <NumberAndTitle
                                num={detailAssessment?.marketPriceGrossIncome ?? 0}
                                tit="上記価格で売却した場合の手残り"
                                roundfunction={commonHelpers.convertTenThousandYenDown}
                            />
                        </div>
                        {/* <div
                            className="title-badge badge-2 center-inside"
                            style={{ marginTop: 33 }}
                        >
                            相場価格の根拠
                        </div>
                        <MoreInfo description={DEMO_DESCRIPTION} />
                        <Button
                            className="button-login-text button-blue-custom"
                            style={{
                                width: '100%',
                                height: 56,
                                marginTop: 18,
                                marginBottom: 24,
                            }}
                        >
                            周辺取引事例を見る
                        </Button> */}
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                marginBottom: 33,
                                marginTop: 40,
                            }}
                        >
                            <NumberAndTitle
                                num={detailAssessment?.nrbxPrice ?? 0}
                                tit="当社買取価格"
                            />
                            <NumberAndTitle
                                num={detailAssessment?.nrbxPriceGrossIncome ?? 0}
                                tit="当社買取価格に対する手残り"
                                roundfunction={commonHelpers.convertTenThousandYenDown}
                            />
                        </div>
                        <div>
                            <h3>想定売却価格で売却した場合の手残りの計算式</h3>
                            <div className="calculation-formula">
                                想定売却価格 - (想定売却価格 x 3% + 6万円) x 1.1 - 残債価格<br/>
                                例 2000万円 - <span className="hightlight-color">( 2000万円 x 3% + 6万円)</span> x 1.1 - 1000万円 = 927.4万円<br/>
                                <span className="hightlight-color">※仲介手数料</span>
                            </div>
                        </div>
                        <div>
                            <h3>当社買取価格に対する手残りの計算式</h3>
                            <div className="calculation-formula" style={{ marginBottom: 30 }}>
                                当社買取価格 - 残債価格<br/>
                                例 2000万円 - <span className="hightlight-color">0</span> - 1000万円 = 1000万円<br/>
                                <span className="hightlight-color">※仲介手数料がかかりません</span>
                            </div>
                        </div>
                        <Form
                            form={form}
                            className="desired-selling-container"
                            style={{ margin: 0 }}
                            onValuesChange={() => {
                                setIsDisabled(form.getFieldValue('price') <= 0);
                            }}
                            onFinish={submit}
                        >
                            <DesiredSellingPrice
                                isDisabled={isDisabled}
                                defaultValue={askingSalePrice}
                                form={form}
                            />
                        </Form>
                        <div style={{ paddingTop: 20, paddingBottom: 20 }}>
                           ※「残債が不明な場合はチェックしてください。」にチェックした場合は、残債０円で計算されます。<br/>
                           ※仲介手数料以外に、登記費用や繰り上げ一括返済手数料などがかかる場合があります。 
                        </div>
                    </section>
                </section>
            </div>
        </>
    );
};
export default CU03301Page;
